export function getComputedStyleProperty(el, property, normalValue) {
    const computed = document.defaultView?.getComputedStyle(el);
    if (!computed)
        return;
    const value = computed.getPropertyValue(property);
    return value === 'normal' ? normalValue ?? value : value;
}
//# sourceMappingURL=utils.js.map